var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('create-task'),expression:"'create-task'"}],attrs:{"block":"","variant":"primary"}},[_vm._v(" Nueva tarea ")])
}
var staticRenderFns = []

export { render, staticRenderFns }